export default {
  home: 'หน้าแรก',
  manageUser: 'จัดการผู้ใช้',
  pleaseLogIn: 'กรุณาเข้าสู่ระบบ',
  username: 'ชื่อผู้ใช้งาน',
  password: 'รหัสผ่าน',
  rememberMe: 'จดจำฉัน',
  forgotPassword: 'ลืมรหัสผ่าน',
  language: 'เปลี่ยนภาษา',
  selectLanguage: 'กรุณาเลือกภาษา',
  thai: 'ไทย',
  english: 'อังกฤษ',
  login: 'เข้าสู่ระบบ',
  vision: 'วิสัยทัศน์',
  mission: 'พันธกิจ',
  value: 'ค่านิยม และวัฒนธรรมองค์กร',
  swotAnalysis: 'การวิเคราะห์ SWOT',
  company: 'บริษัท',
  competencyScore: 'ช่วงเกณฑ์คะแนนคุณภาพ',
  competencyScoreGroup: 'กลุ่มช่วงเกณฑ์คะแนนคุณภาพ',
  competencyScoreGroupName: 'ชื่อกลุ่มช่วงเกณฑ์คะแนนคุณภาพ',
  addGroup: 'เพิ่มกลุ่ม',
  companyInfo: 'ข้อมูลบริษัท',
  filter: 'ตัวกรอง',
  search: 'ค้นหา',
  cancel: 'ยกเลิก',
  corporate: 'องค์กร',
  companyCode: 'รหัสบริษัท',
  companyName: 'ชื่อบริษัท',
  lineBusiness: 'กลุ่มธุรกิจ',
  active: 'ใช้งาน',
  inactive: 'ไม่ได้ใช้งาน',
  export: 'ส่งออก',
  import: 'นำเข้า',
  download: 'ดาวน์โหลด',
  searchFor: 'ค้นหา',
  general: 'ทั่วไป',
  parentCompany: 'บริษัทต้นสังกัด',
  about: 'เกี่ยวกับ',
  config: 'กำหนดค่า',
  save: 'บันทึก',
  file: 'ไฟล์',
  saveAndAddAnother: 'บันทึก & เพิ่มต่อ',
  passwordPolicy: 'ข้อกำหนดรหัสผ่าน',
  passwordExpiration: 'รหัสผ่านหมดอายุ',
  ldap: 'แอลแด็ป',
  createby: 'สร้างโดย',
  eMailServer: 'อีเมลเซิร์ฟเวอร์',
  updateby: 'แก้ไขโดย',
  dataIntegration: 'รวบรวมข้อมูล',
  lastExecute: 'ดำเนินการล่าสุด',
  selectTable: 'เลือกตาราง',
  destinationTable: 'ข้อมูลปลายทาง',
  sourceConnection: 'ข้อมูลต้นทาง',
  sqlSourceTable: 'กำหนดเอสคิวแอล',
  execute: 'รัน',
  sampleData: 'ข้อมูลตัวอย่าง',
  getField: 'เรียกฟิลด์',
  mappingField: 'จับคู่ฟิลด์',
  sourceField: 'ฟิลด์แหล่งข้อมูล',
  destinationField: 'ฟิลด์แหล่งข้อมูลปลายทาง',
  add: 'เพิ่ม',
  del: 'ลบ',
  namePasswordPolicy: 'ชื่อข้อกำหนดรหัสผ่าน',
  changeable: 'อนุญาติเปลี่ยนแปลง',
  minimumAge: 'ระยะเวลาขั้นต่ำ',
  resetTicketMaxAge: 'จำนวนสูงสุดการเปลี่ยน',
  passwordSyntaxchecking: 'ตรวจสอบรูปแบบ',
  syntaxCheckingEnabled: 'เปิดใช้งานตรวจสอบรูปแบบ',
  historyEnabled: 'เปิดใช้งานประวัติ',
  minimumAlphaNumeric: 'จำนวนอักขระพิเศษ',
  minimumLength: 'ความยาวอักขระ',
  minimumLowerCase: 'จำนวนตัวพิมพ์เล็ก',
  minimumNumbers: 'จำนวนตัวเลข',
  minimumSymbols: 'จำนวนสัญลักษณ์',
  minimumUpperCase: 'จำนวนพิมพ์ใหญ่',
  regularExpression: 'กำหนดรูปแบบทั่วไป',
  passwordHistory: 'ประวัติรหัสผ่าน',
  historyExpriation: 'ประวัติการหมดอายุ',
  maximemAge: 'ระยะเวลาก่อนเปลี่ยน',
  warningTime: 'แจ้งเตือนรหัสหมดอายุ',
  graceLimit: 'จำนวนครั้งการเข้า',
  lockout: 'ล็อคระบบ',
  lockoutEnabled: 'เปิด/ปิด',
  maximumFailure: 'จำนวนครั้งที่ใส่รหัสผิด',
  resetFailureCount: 'ระยะเวลาใส่รหัสผิด',
  lockoutDuration: 'ระยะเวลาล็อค',
  serverName: 'ชื่อเซิร์ฟเวอร์',
  baseProviderURL: 'ยูอาร์แอลผู้ให้บริการ',
  baseDN: 'ฐาน ดีเอ็น',
  users: 'ผู้ใช้งาน',
  userMapping: 'จับคู่ผู้ใช้งาน',
  uuid: 'ยูยูไอดี',
  emailAddress: 'ที่อยู่อีเมล',
  firstName: 'ชื่อ',
  lastName: 'นามสกุล',
  groupMapping: 'จับคู่กลุ่ม',
  groupName: 'ชื่อกลุ่ม',
  testldapGroups: 'ทดสอบ',
  organization: 'หน่วยงาน',
  code: 'รหัส',
  organizationName: 'ชื่อหน่วยงาน',
  organizationLevel: 'ระดับหน่วยงาน',
  parentCode: 'รหัสต้นสังกัด',
  level: 'ระดับ',
  abbreviation: 'ตัวย่อ',
  eMail: 'อีเมล',
  effectiveDate: 'วันที่มีผล',
  position: 'ตำแหน่ง',
  positionName: 'ชื่อตำแหน่ง',
  positionGroup: 'กลุ่มตำแหน่ง',
  positionGroupCode: 'รหัสกลุ่มตำแหน่ง',
  seqNo: 'ลำดับขั้น',
  positionGroupName: 'ชื่อกลุ่มตำแหน่ง',
  role: 'สิทธิ์ใช้งาน',
  roleName: 'ชื่อสิทธิ์ใช้งาน',
  admin: 'ผู้ดูแลระบบ',
  dataAccess: 'เข้าถึงข้อมูล',
  access: 'เข้าถึง',
  specificCompany: 'เฉพาะบริษัท',
  specificOrg: 'เฉพาะหน่วยงาน',
  orgHierarchy: 'หน่วยงานสังกัดและลำดับขั้น',
  ownOrg: 'เฉพาะหน่วยงานที่สังกัด',
  orgLevel: 'ระดับหน่วยงาน',
  page: 'หน้าจอ',
  pageAccess: 'การเข้าถึงหน้าจอ',
  assignUser: 'เพิ่มผู้ใช้งาน',
  assignRole: 'มอบหมายตำแหน่ง',
  view: 'ดู',
  edit: 'แก้ไข',
  delete: 'ลบ',
  setupData: 'ตั้งค่าข้อมูลพื้นฐาน',
  user: 'ผู้ใช้งาน',
  userName: 'ชื่อผู้ใช้งาน',
  confirmPassword: 'ยืนยันรหัสผ่าน',
  confirm: 'ยืนยัน',
  manage: 'จัดการ',
  appraisalFormName: 'ชื่อแบบฟอร์มการประเมิน',
  appraisalYear: 'ปีการประเมิน',
  startDate: 'วันที่เริ้มต้น',
  endDate: 'วันที่สิ้นสุด',
  structure: 'โครงสร้างการประเมิน',
  structureName: 'ชื่อโครงสร้างการประเมิน',
  structureType: 'ประเภทโครงสร้าง',
  targetScore: 'เป้าคะแนน',
  orderSeq: 'ลำดับ',
  valueGetZero: 'ค่าที่ไม่ได้คะแนน',
  unlimitedDeduction: 'หักคะแนนมากกว่าที่น้ำหนักกำหนด',
  permission: 'การเข้าถึงข้อมูล',
  appraisalType: 'ประเภทการประเมิน',
  levelName: 'ชื่อระดับ',
  parentLevel: 'ระดับต้นสังกัด',
  midpoint: 'ค่ากลาง',
  district: 'เขต',
  appraisalCriteria: 'เกณฑ์การประเมิน',
  appraisalLevel: 'ระดับขั้นการประเมิน',
  appraisalCriteriaName: 'ชื่อเกณฑ์การประเมิน',
  setWeight: 'กำหนดน้ำหนัก',
  setAssessor: 'กำหนดกลุ่มผู้ประเมิน',
  setPosition: 'กำหนดตำแหน่งผู้ประเมิน',
  select: 'เลือก',
  group: 'กลุ่ม',
  caseNo: 'ลำดับเคส',
  appraisal: 'ประเมิน',
  appraisalItem: 'หัวข้อประเมิน',
  appraisalItemCode: 'รหัสหัวข้อประเมิน',
  appraisalItemName: 'ชื่อหัวข้อประเมิน',
  header: 'ส่วนหลัก',
  itemCode: 'รหัสข้อหัวประเมิน',
  kpi: 'KPI',
  kpiType: 'ประเภท KPI',
  kpiTypeName: 'ชื่อประเภท KPI',
  kpiParent: 'ต้นสังกัด KPI',
  parentItem: 'หัวข้อต้นสังกัด',
  parentName: 'ชื่อต้นสังกัด',
  uom: 'หน่วยวัดผล',
  perspective: 'มุมมอง',
  perspectiveName: 'ชื่อของมุมมอง',
  valueType: 'ประเภทค่า',
  functionType: 'ประเภทฟังก์ชั่น',
  formula: 'สูตร',
  formulaDescription: 'คำอธิบายสูตร',
  performanceLevel: 'ระดับประสิทธิภาพ',
  description: 'คำอธิบาย',
  isShowVariance: 'ความแปรปรวน',
  competencyType: 'ประเภทหัวข้อประเมินเชิงคุณภาพ',
  proficiencyLevel: 'อธิบายคุณสมบัติการประเมิน',
  deductName: 'ชื่อหัวข้อ',
  maxValue: 'ค่าสูงสุด',
  deductScoreUnit: 'หักคะแนน',
  status: 'สถานะ',
  copyTo: 'คัดลอกให้',
  copyAssignment: 'คัดลอกการมอบหมาย',
  form: 'แบบฟอร์ม',
  formName: 'ชื่อแบบฟอร์ม',
  assign: 'มอบหมาย',
  unassign: 'ยังไม่ได้มอบหมาย',
  assignment: 'การมอบหมาย',
  assignDate: 'วันที่มอบหมาย',
  structureWeight: 'น้ำหนักโครงสร้าง',
  condition: 'เงื่อนไข',
  threshold: 'เกณฑ์คะแนน',
  thresholdGroup: 'ช่วงเกณฑ์คะแนน',
  prorate: 'คิดตามสัดส่วน',
  approve: 'อนุมัติ',
  kpiCode: 'รหัสตัวชี้วัด',
  kpiName: 'ชื่อตัวชี้วัด',
  target: 'เป้า',
  frequency: 'ความถี่',
  daily: 'รายวัน',
  weekly: 'รายสัปดาห์',
  quarterly: 'รายไตรมาส',
  monthly: 'รายเดือน',
  halfYearly: 'รายครึ่งปี',
  biannually: 'รายครึ่งปี',
  yearly: 'รายปี',
  weightPercent: '%น้ำหนัก',
  weightScore: 'น้ำหนักคะแนน',
  waive: 'ยกเลิก',
  deployable: 'นำไปใช้',
  adoptable: 'รับผล',
  applyAll: 'ใช้ทั้งหมด',
  responsible: 'ผู้รับผิดชอบ',
  remark: 'หมายเหตุ',
  action: 'แอคชั่น',
  review: 'ตรวจสอบ',
  draft: 'ฉบับร่าง',
  reject: 'ตีกลับ',
  start: 'เริ่มต้น',
  end: 'เสร็จสิ้น',
  all: 'ทั้งหมด',
  totalPercentWeight: 'รวม%น้ำหนัก ',
  totalScore: 'คะแนนรวม',
  expectation: 'ค่าความคาดหวัง',
  deduct: 'หักคะแนน',
  individual: 'รายบุคคล',
  resultType: 'ประเภทของผลลัพธ์',
  color: 'สี',
  colorCode: 'รหัสสี',
  criteriaName: 'เกณฑ์',
  empCode: 'รหัสพนักงาน',
  empType: 'ประเภทพนักงาน',
  employee: 'พนักงาน',
  employeeName: 'ชื่อพนักงาน',
  employeeLevel: 'ระดับพนักงาน',
  calculate: 'คำนวณ',
  adjust: 'ปรับเกรด',
  adjustName: 'ชื่อการปรับปรุง',
  setting: 'ตั้งค่า',
  profile: 'ข้อมูลส่วนตัว',
  signOut: 'ออกจากระบบ',
  minutes: 'นาที',
  minute: 'นาที',
  hours: 'ชั่วโมง',
  hour: 'ชั่วโมง',
  week: 'สัปดาห์',
  weeks: 'สัปดาห์',
  year: 'ปี',
  month: 'เดือน',
  day: 'วัน',
  days: 'วัน',
  details: 'รายละเอียด',
  doNotWarn: 'ไม่แจ้งเตือน',
  unlockedByAdmin: 'จนกว่าแอดมินจะปลดล็อค',
  workingStartDate: 'วันที่เริ่มงาน',
  workingAge: 'อายุงาน',
  max_validate: 'ข้อมูลขนาดเกินใหญ่เกินที่กำหนด',
  unique_validate: 'มีข้อมูลนี้แล้ว',
  numeric_validate: 'ข้อมูลเป็นตัวเลขเท่านั้น',
  string_validate: 'ข้อมูลเป็นข้อความเท่านั้น',
  boolean_validate: 'ข้อมูลเป็นค่าความจริงเท่านั้น',
  between_validate: 'ข้อมูลไม่ได้อยู่ในช่วงที่กำหนด',
  required_validate: 'จำเป็นต้องใช้ข้อมูลนี้',
  exists_validate: 'ไม่มีคีย์นี้',
  date_validate: 'ข้อมูลเป็นวันที่เท่านั้น',
  '2000': 'ข้อมูลนี้ถูกใช้งานอยู่ ไม่สามารถลบได้',
  '2002': 'ข้อมูลซ้ำ',
  is_Main: 'ตำแหน่งหลัก',
  action_To: 'สายปฏิบัติงาน',
  delegate: 'ตัวแทน',
  assignmentDate: 'วันที่มอบหมาย',
  confirmDel: 'ยืนยันที่จะลบหรือไม่',
  forceRank: 'การคำนวณคะแนน และเกรด',
  criteria: 'เกณฑ์',
  date: 'วันที่',
  summary: 'ผล',
  levelGroup: 'กลุ่มระดับ',
  levelGroupName: 'ชื่อกลุ่มระดับ',
  addAssignment: 'เพิ่มการมอบหมาย',
  cancelAssignment: 'ยกเลิกการมอบหมาย',
  rejectReason: 'เหตุผลที่ปฏิเสธ',
  confirmLeavePage: 'คุณแน่ใจที่จะออกจากหน้านี้? ข้อมูลที่ไม่ได้บันทึกจะหายไป',
  weightValidationHelperText: 'ค่าน้ำหนักต้องมีค่าระหว่าง 0 ถึง 100',
  cannotDeployMultiTarget: 'ไม่สามารถ deploy เนื่องจากเลือก มอบหมายมากกว่า 1 กรุณาเลือกอีกครั้ง',
  addItem: 'เพิ่ม KPI',
  removeItem: 'ลบ KPI',
  totalWeightValidationHelperText: 'น้ำหนักรวมต้องเท่ากับ 100%',
  totalValidation: 'น้ำหนักรวมต้องเท่ากับ ',
  targetValue: 'เป้า',
  targetRange1: 'ช่วงเป้า 1',
  targetRange2: 'ช่วงเป้า 2',
  targetRange3: 'ช่วงเป้า 3',
  targetRange4: 'ช่วงเป้า 4',
  targetRange5: 'ช่วงเป้า 5',
  actualValue: 'ผลที่ได้',
  jan: 'ม.ค.',
  feb: 'ก.พ.',
  mar: 'มี.ค.',
  apr: 'เม.ย.',
  may: 'พ.ค.',
  jun: 'มิ.ย.',
  jul: 'ก.ค.',
  aug: 'ส.ค.',
  sep: 'ก.ย.',
  oct: 'ต.ค.',
  nov: 'พ.ย.',
  dec: 'ธ.ค.',
  q1: 'ไตรมาส-1',
  q2: 'ไตรมาส-2',
  q3: 'ไตรมาส-3',
  q4: 'ไตรมาส-4',
  half1: 'ครึ่งปีแรก',
  half2: 'ครึ่งปีหลัง',
  competencyCode: 'รหัสหัวข้อชี้วัด',
  competencyName: 'คุณภาพ',
  score: 'คะแนน',
  overValue: 'ส่วนต่าง',
  comment: 'ความคิดเห็น',
  reply: 'แสดงความเห็น',
  cancelAppraisal: 'ยกเลิกการใส่ผล',
  completeAssigned: 'มอบหมายแล้ว (ทั้งหมด)',
  incompleteAssigned: 'มอบหมายแล้ว (บางส่วน)',
  commentRequiredWhenScoreOver80Percent: 'ต้องใส่เหตุผลเมื่อคะแนนเกิน 80% ของเป้าหมาย',
  scoreIsHigherThanTarget: 'คะแนนไม่สามารถมีค่ามากกว่าค่าเป้าหมาย',
  resulted: 'ประเมินแล้ว',
  notResulted: 'ยังไม่ประเมิน',
  assessor: 'ผู้ประเมิน',
  assessorGroup: 'กลุ่มผู้ประเมิน',
  assignmentEndDate: 'วันสิ้นสุดการประเมิน',
  usageLog: 'บันทึกการใช้งาน',
  usageDateTime: 'วันที่ใช้งาน',
  fullName: 'ชื่อเต็ม',
  pageName: 'ชื่อเพจ',
  dataId: 'รหัสข้อมูล',
  tableUsageLog: 'ข้อการใช้งาน',
  grade: 'คะแนน',
  no: 'อันดับ',
  forceRankIndex: 'คะแนนอินเด็กซ์',
  indexTable: 'ตารางคะแนน',
  adjustGradeTable: 'ตารางปรับเกรด',
  individualKPI: 'ตัวชี้วัด',
  attendance: 'หักคะแนน',
  dashboardBranchPerformance: 'ประสิทธิภาพของสาขา',
  dashboardOverallPerformance: 'ประสิทธิภาพโดยรวม',
  dashboardPerformanceComparison: 'เปรียบเทียบประสิทธิภาพรายบุคคล',
  dashboardPerformanceTrend: 'ผลการประเมินรายหัวข้อ',
  reportAppraisal: 'สรุปผลการประเมิน',
  reportDataEntry: 'สถานะการบันทึกข้อมูลผลของชุดข้อมูล',
  reportKpi: 'สรุปผลประสิทธิภาพ KPI',
  reportPerformanceForm: 'แบบประเมินผลการปฎิบัติงานรายบุคคล',
  branchPerformance: 'ประสิทธิภาพของสาขา',
  overallPerformance: 'ประสิทธิภาพโดยรวม',
  performanceComparison: 'เปรียบเทียบประสิทธิภาพรายบุคคล',
  performanceTrend: 'ผลการประเมินรายหัวข้อ',
  appraisalSummary: 'สรุปผลการประเมิน',
  dataEntryStatus: 'สถานะการบันทึกข้อมูลผลของชุดข้อมูล',
  kpiSummary: 'สรุปผลประสิทธิภาพ KPI',
  performanceForm: 'แบบประเมินผลการปฎิบัติงานรายบุคคล',
  dashboard: 'กราฟแสดงผล',
  report: 'รายงาน',
  deleteComment: 'ลบความคิดเห็น',
  confirmDeleteData: 'ข้อมูลจากการคำนวณจะถูกลบยืนยันหรือไม่?',
  confirmClearGrade: 'ข้อมูลเกรดจะถูกล้าง ยืนยันหรือไม่?',
  individualAssignment: 'การมอบหมายรายบุคคล',
  corporateAssignment: 'การมอบหมายระดับองค์กร',
  setOption: 'ตั้งค่าเพิ่มเติม',
  province: 'จังหวัด',
  channel: 'ช่องทาง',
  selectAll: 'เลือกทั้งหมด',
  LOW: 'น้อย',
  MED: 'กลาง',
  HIGHT: 'มาก',
  '400': 'ข้อมูลผิดพลาด',
  '401SE': 'เซสชั่นหมดอายุ กรุณาล็อคอินอีกครั้ง',
  '401LI': 'ชื่อผู้ใช้หรือรหัสผ่านผิด กรุณาลองใหม่อีกครั้ง',
  '401NA': 'คุณไม่มีสิทธิในการเข้าถึงข้อมูลนี้',
  '404': 'ไม่พบข้อมูล',
  '500': 'เซิร์ฟเวอร์มีปัญหา กรุณาลองใหม่อีกครั้ง',
  alertGrade: 'เกิดข้อผิดพลาด : กรุณาระบุเกรดให้ครบตามจำนวนที่กำหนด',
  budget: 'จำนวน',
  amount: 'ผลรวม',
  indexCalculation: 'คำนวณ',
  AdjustGrade: 'กำหนดเกรด',
  ForceRankSuccess: 'คำนวณเกรดสำเร็จ',
  SomeStatusNotClose: 'สถานะของผู้ประเมินยังไม่สมบูรณ์ กรุณาตรวจสอบ',
  IndexCalculateSuccess: 'คำนวณสำเร็จ',
  AdjustGradeCreated: 'ปรับปรุงเกรดสำเร็จ',
  InvalidAdjustGradeField: 'ปรับฟิลด์เกรดไม่ถูกต้อง',
  IndexCalculateTab: 'คำนวณคะแนน',
  ForceRankTab: 'กำหนดเกรด',
  'unable-to-assign-competency-because-the-result-action2-was-not-found':
    'ไม่สามารถมอบหมายได้ เนื่องจากไม่มีผู้ประเมิน',
  'LOWX,LOWY': 'LOWX,LOWY',
  'LOWX,MEDY': 'LOWX,MEDY',
  'LOWX,HIGHY': 'LOWX,HIGHY',
  'LOWX,HIGHERY': 'LOWX,HIGHERY',
  'MEDX,LOWY': 'MEDX,LOWY',
  'MEDX,MEDY': 'MEDX,MEDY',
  'MEDX,HIGHY': 'MEDX,HIGHY',
  'MEDX,HIGHERY': 'MEDX,HIGHERY',
  'HIGHX,LOWY': 'HIGHX,LOWY',
  'HIGHX,MEDY': 'HIGHX,MEDY',
  'HIGHX,HIGHY': 'HIGHX,HIGHY',
  'HIGHX,HIGHERY': 'HIGHX,HIGHERY',
  'HIGHERX,LOWY': 'HIGHERX,LOWY',
  'HIGHERX,MEDY': 'HIGHERX,MEDY',
  'HIGHERX,HIGHY': 'HIGHERX,HIGHY',
  'HIGHERX,HIGHERY': 'HIGHERX,HIGHERY',
  LOWX: 'น้อย',
  LOWY: 'น้อย',
  MEDX: 'กลาง',
  MEDY: 'กลาง',
  HIGHX: 'มาก',
  HIGHY: 'มาก',
  HIGHERX: 'มากกว่าเป้า',
  HIGHERY: 'มากกว่าเป้า',
  example: 'ตัวอย่าง',
  noRecordsToDisplay: 'ไม่มีข้อมูลที่ค้นหา',
  close: 'ปิด',
  next: 'ต่อไป',
  previous: 'ก่อนหน้า',
  back: 'ย้อนกลับ',
  assignmentEndDateValidation: 'วันสิ้นสุดการประเมินต้องมากกว่าวันที่มอบหมาย',
  assessorScore: 'คะแนน',
  'emp-action-2-not-found': 'ไม่สามารถมอบหมายได้ เนื่องจากพนักงานนี้ไม่มีผู้ประเมิน',
  thresholds: 'เกณฑ์คะแนน',
  pageNotFound: 'ไม่พบหน้าที่ค้นหา',
  showing: 'กำลังแสดง',
  records: 'เรคคอร์ด',
  of: 'ใน',
  achievement: 'ความสำเร็จ',
  perspectivePerformance: 'ประสิทธิภาพมุมมอง',
  kpiPerformance: 'ประสิทธิภาพตัวชี้วัด',
  allKpi: 'ตัวชี้วัดทั้งหมด',
  impactLevel: 'ความสำคัญ',
  urgencyLevel: 'ห่างเป้า',
  actual: 'ผลงาน',
  percentAchievement: '% ความสำเร็จ',
  atDate: 'ณ วันที่',
  allkpi: 'ตัวชี้วัดทั้งหมด',
  expandAll: 'ขยาย',
  collapseAll: 'ย่อ',
  noDataDisplay: 'ไม่พบข้อมูลในการแสดงผล',
  roleAssignment: 'มอบหมายสิทธ์การใช้งาน',
  getPassword: 'ขอรับรหัสผ่าน',
  forgetPassword: 'ลืมพาสเวิร์ด',
  getPasswordInEmail: 'รหัสผ่านใหม่จะถูกส่งไปที่อีเมลล์',
  confirmation: 'กรุณายืนยัน',
  isDate: 'เป็นวันที่',
  format: 'รูปแบบรายงาน',
  pleaseFilter: 'กรุณาเลือกตัวกรองข้อมูล...',
  pagiPage: 'หน้าที่',
  pagiPerPage: 'จำนวนต่อหน้า',
  tag: 'แท็ก',
  competencyMax: 'คะแนนเต็ม',
  accomplishmentFrom: 'รับผลงาน',
  commentRequiredWhenScoreEqualOrOverExpectation:
    'กรุณาระบุหมายเหตุเนื่องจากใส่คะแนนเท่ากับหรือมากกว่าค่าคาดหวัง',
  precisionIsNotEven: 'ทศนิยมไม่ได้เป็นเลขคู่',
  positionGroupLevel: 'ระดับกลุ่มตำแหน่ง',
  allCompany: 'ทุกบริษัท',
  positionGroupLevelAccess: 'การเข้าถึงระดับกลุ่มตำแหน่ง',
  addCase: 'เพิ่มเคส',
  stage: 'สเตจ',
  competency: 'คุณภาพ',
  task: 'งาน',
  actualStart: 'เริ่มผลงาน',
  actualEnd: 'สิ้นสุดผลงาน',
  planStart: 'เริ่มแผนงาน',
  planEnd: 'สิ้นสุดแผนงาน',
  phase: 'เฟส',
  actionPlan: 'แผนปฏิบัติการ',
  taskNameIsRequired: 'จำเป็นต้องใส่ชื่องาน',
  totalGradeValidationHelperText: 'เกรดรวมต้องมีค่า 100 หรือ 0',
  totalGradeValidationText: 'เกรดรวมต้องมีค่า 100',
  gradeCriteria: 'เกณฑ์การกำหนดเกรด',
  gradeCriteriaName: 'ชื่อเกณฑ์การกำหนดเกรด',
  gradeCondition: 'เงื่อนไขเกรด',
  beginScore: 'คะแนนเริ่มต้น',
  endScore: 'คะแนนสิ้นสุด',
  salaryRaise: '% เรทเงินเดือน',
  percentBudget: '% Budget',
  bonusMonth: 'โบนัส',
  performance: 'ประสิทธิภาพ',
  scoreIsHigherThanCompetencyMax: 'คะแนนไม่สามารถมีค่ามากกว่าคะแนนเต็ม ',
  importSalary: 'นำเข้าข้อมูลเงินเดือน',
  browseOrDropFileHere: 'เลือกไฟล์ หรือวางไฟล์ที่นี่',
  salary: 'เงินเดือน',
  salaryData: 'ข้อมูลเงินเดือน',
  forceRankGroup: 'กลุ่มการคำนวณคะแนน',
  forceRankGroupName: 'ชื่อกลุ่มการคำนวณคะแนน',
  budgetSalary: 'Budget Salary',
  budgetBonus: 'Budget Bonus',
  isForceRank: 'Is Force Rank',
  sumUp: 'รวมยอด',
  calLoading: 'กำลังคำนวณ',
  loading: 'กำลังโหลด',
  forceRankVertical: 'การคำนวณคะแนน และเกรดตามสายงาน',
  forceRankHorizontal: 'การคำนวณคะแนน และเกรดตามระดับงาน',
  forceRankHorizontalDirec: 'Horizontal Force rank (Director)',
  forceRankHorizontalBoard: 'Horizontal Force rank (Board)',
  raiseAmount: 'จำนวนเงินที่ขึ้น',
  extraRaiseAmount: 'Extra Raise Amount',
  extraRaise: 'Extra Raise%',
  extraBonusMonth: 'Extra Bonus Month',
  extraBonus: 'Extra Bonus',
  finalBonus: 'Final Bonus',
  raise: 'จำนวนเปอร์เซ็นต์ที่ขึ้น',
  newSalary: 'เงินเดือนใหม่',
  bonus: 'โบนัส',
  old: 'เงินเดือนปัจจุบัน',
  raiseReverse: '%เพิ่ม',
  total: 'ทั้งหมด',
  commentIsRequired: 'จำเป็นต้องใส่คอมเม้น',
  commentIsRequiredMin150: 'จำเป็นต้องใส่คอมเม้น (อย่างต่ำ 150 ตัวอักษร)',
  commentIsRequiredMin100: 'จำเป็นต้องใส่คอมเม้น (อย่างต่ำ 100 ตัวอักษร)',
  sumIsNot100: 'ผลรวมไม่เท่ากับ 100',
  reportAppraisalByOrg: 'สรุปผลการประเมินหน่วยงาน',
  reportAppraisalByLevel: 'สรุปผลการประเมินตามระดับ',
  reportBonusSalary: 'สรุปยอดโบนัสและเงินเดือน',
  probationEndDate: 'วันที่ผ่านทดลองงาน',
  coachingAndFeedback: 'Coaching and Feedback',
  feedback: 'Feedback',
  feedbackReport: 'รายงาน Feedback',
  is_vfr: 'Is_VFR'
}
